import { IconCalendar, IconChevronLeft, IconChevronRight, IconRefresh, IconSearch } from '@tabler/icons-react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import { useNavigate } from 'react-router-dom';
import Input from '../../components/Input';
import { getAuthorizationHeader, http, imageBaseUrl } from '../../config/http';
import Layouts from '../../layouts/Layouts';
import { DinamicTitle } from '../../utils/DinamicTitle';
import { IconReload } from '@tabler/icons-react';
import useKarat from '../features/useKarat';
import DetailBarangPenjualan from '../Transaksi/DetailBarangPenjualan';
import { PhotoView } from 'react-photo-view';

const GaleriPenjualan = () => {
    const navigate = useNavigate();
    const { karatOption, karatOptionId, setKaratOptionId } = useKarat();
    const [trxPenjualan, setTrxPenjualan] = useState([]);
    // console.log(trxPenjualan)
    const [openLoading, setOpenLoading] = useState(false);
    const [detailPenjualan, setDetailPenjualan] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectCabang, setSelectCabang] = useState([]);
    const [idCabang, setIdCabang] = useState(0);
    const [idKategori, setIdKategori] = useState(0);
    const [kategori, setKategori] = useState([]);

    const [openCalender, setOpenCalender] = useState(false);
    const [filterDate, setFilterDate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const awal = moment(startDate).format('DD-MM-YYYY');
    const akhir = moment(endDate).format('DD-MM-YYYY');

    // const [totalHargaPenjualan, setTotalHargaPenjualan] = useState(0);
    // const [totalHargaFilter, setTotalHargaFilter] = useState(0);

    const [filterBerat, setFilterBerat] = useState('');
    const [berat, setBerat] = useState('');

    const filterBeratBarang = () => {
        setBerat(filterBerat);
    };

    const [selectedKategori, setSelectedKategori] = useState('');
    const [selectJenisKategori, setSelectJenisKategori] = useState('');

    const handleKategoriChange = (event) => {
        setSelectedKategori(event.target.value);
        setSelectJenisKategori('');
    };

    const handleJenisKategoriChange = (event) => {
        setSelectJenisKategori(event.target.value);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [search, setSearch] = useState('');

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    const [itemsPerPage, setItemsPerPage] = useState('');
    const startIndex = (currentPage - 1) * itemsPerPage;

    useEffect(() => {
        async function getTrxPenjualan() {
            setLoading(true);
            await http
                .get(
                    `penjualan${search === '' ? `?page=${currentPage}` : `?faktur=${search}`}${(idCabang === 0 || idCabang === '') ? `` : `&cabang=${idCabang}`}
          ${(selectedKategori === 0 || selectedKategori === '') ? `` : `&kategori=${selectedKategori}`}${(selectJenisKategori === 0 || selectJenisKategori === '') ? `` : `&jenis_kategori=${selectJenisKategori}`}${startDate === null && endDate === null ? `` : `&tgl_awal=${awal}&tgl_akhir=${akhir}`
                    }${karatOptionId === '' ? '' : `&karat=${karatOptionId}`}${berat === '' ? '' : `&berat=${berat}`}`,
                    {
                        headers: { Authorization: getAuthorizationHeader() },
                    },
                )
                .then((res) => {
                    setTrxPenjualan(res.data.data.data);
                    setCurrentPage(res.data.data.current_page);
                    setItemsPerPage(res.data.data.per_page);
                    setLastPage(res.data.data.last_page);
                    return res.data.data;
                })
                .catch((err) => {
                    if (err.response === 'undefined') {
                        return null;
                    } else if (err.response.status === 401) {
                        navigate('/login');
                    }
                });
            setLoading(false);
        }
        getTrxPenjualan();
    }, [
        idCabang,
        // idKategori,
        search.length >= 12 ? search : '',
        awal,
        akhir,
        startDate,
        endDate,
        currentPage,
        navigate,
        karatOptionId,
        berat,
        selectedKategori,
        selectJenisKategori,
    ]);

    let [isOpen, setIsOpen] = useState(false);

    function closeModal() {
        setIsOpen(false);
    }
    async function showDetailPenjualan(id) {
        setOpenLoading(true);
        await http
            .get(`penjualan/${id}`, {
                headers: { Authorization: getAuthorizationHeader() },
            })
            .then((res) => {
                setDetailPenjualan(res.data.data);
                setIsOpen(true);
            });
        setOpenLoading(false);
    }

    useEffect(() => {
        async function getCabangSelect() {
            await http
                .get(`cabang?is_toko=1`, {
                    headers: { Authorization: getAuthorizationHeader() },
                })
                .then((res) => {
                    setSelectCabang(res.data.data);
                })
                .catch((err) => {
                    if (err.response === 'undefined') {
                        return null;
                    } else if (err.response.status === 401) {
                        navigate('/login');
                    }
                });
        }
        getCabangSelect();
    }, [navigate]);

    useEffect(() => {
        async function getKategori() {
            await http
                .get('/kategori', {
                    headers: { Authorization: getAuthorizationHeader() },
                })
                .then((res) => {
                    setKategori(res.data);
                })
                .catch((err) => {
                    if (err.response === 'undefined') {
                        return null;
                    } else if (err.response.status === 401) {
                        navigate('/login');
                    }
                });
        }
        getKategori();
    }, []);

    const selectionRange = {
        startDate: startDate,
        endDate: endDate,
        key: 'selection',
    };

    function handleSelect(date) {
        // console.log('date::: ', date);
        setStartDate(date.selection.startDate);
        setEndDate(date.selection.endDate);
    }

    function checkBerat(number) {
        const beratConfirm = parseFloat(number);
        return beratConfirm % 1 === 0
            ? beratConfirm.toString()
            : beratConfirm
                .toFixed(2)
                .replace(/\.?0+$/, '')
                .replace('.', ',');
    }

    DinamicTitle('Galeri Penjualan');

    return (
        <Layouts
            title={'Galeri Penjualan'}
            compFilter={
                <div className="flex items-center gap-1.5">
                    <div className="dropdown dropdown-bottom">
                        <div
                            tabIndex={0}
                            onClick={() => setOpenCalender(!openCalender)}
                            className="bg-amber-500 hover:bg-amber-600 text-white p-2 rounded-md cursor-pointer transition-colors shadow-sm"
                        >
                            <IconCalendar className="text-white" />
                        </div>
                        <div tabIndex={0} className="dropdown-content menu -right-40 p-2 shadow-xl bg-white dark:bg-slate-800 rounded-xl border dark:border-slate-700 z-50">
                            <DateRangePicker ranges={[selectionRange]} onChange={handleSelect} />
                        </div>
                    </div>
                    <div onClick={() => window.location.reload()} className="bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 p-2 rounded-md cursor-pointer transition-colors shadow-sm">
                        <IconReload />
                    </div>
                    <div className="flex justify-end">
                        <Input
                            className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                            type="text"
                            onChange={(e) => setSearch(e.target.value)}
                            autoComplete="off"
                            placeholder="Cari Penjualan"
                        />
                    </div>
                </div>
            }
        >
            <div>
                <div className="flex items-center gap-2 w-full scrollbar overflow-x-auto bg-white dark:bg-slate-900 p-2">
                    <select
                        onChange={(e) => setIdCabang(e.target.value)}
                        className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                    >
                        <option value="">Etalase</option>
                        {selectCabang.map((cb) => (
                            <option value={cb.id} key={cb.id}>
                                {cb.nama_cabang}
                            </option>
                        ))}
                    </select>

                    <select
                        value={selectedKategori}
                        onChange={handleKategoriChange}
                        className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                    >
                        <option value="">Kategori</option>
                        {kategori.map((item) => (
                            <option key={item.id} value={item.id}>
                                {item.nama_kategori}
                            </option>
                        ))}
                    </select>

                    {selectedKategori && (
                        <select
                            onChange={handleJenisKategoriChange}
                            value={selectJenisKategori}
                            className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                        >
                            <option value="">Jenis Kategori</option>
                            {kategori
                                .find((kt) => kt.id == selectedKategori)
                                ?.jenis_kategori.map((jk) => (
                                    <option key={jk.id} value={jk.id}>
                                        {jk.nama_jenis}
                                    </option>
                                ))}
                        </select>
                    )}

                    <select
                        onChange={(e) => setKaratOptionId(e.target.value)}
                        className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                    >
                        <option value="">Karat</option>
                        {karatOption.map((kto) => (
                            <option key={kto} value={kto}>
                                {kto}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <DetailBarangPenjualan
                        label={'Penjualan'}
                        checkBerat={checkBerat}
                        closeModal={closeModal}
                        detailPenjualan={detailPenjualan}
                        isOpen={isOpen}
                    />
                    {openLoading ? (
                        <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20 opacity-75 flex flex-col items-center justify-center">
                            <div className="w-12 h-12 rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent"></div>
                        </div>
                    ) : (
                        ''
                    )}
                    {loading ? (
                        <div className="flex items-center justify-center py-10">
                            <div className="w-8 h-8 rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent"></div>
                            <span className="ml-3 text-sm font-medium text-slate-500 dark:text-slate-400">Memuat data...</span>
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 p-4 md:p-5 mb-20">
                            {trxPenjualan.map((trx, index) => {
                                return (
                                    <div key={index} className="relative group rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900">
                                        <PhotoView
                                            src={trx?.item?.gambar1 === null ? '' : `${imageBaseUrl}${trx?.item?.gambar1[0]?.asli}`}
                                        >
                                            <img
                                                src={trx?.item?.gambar1 === null ? '' : `${imageBaseUrl}${trx?.item?.gambar1[0]?.asli}`}
                                                alt=""
                                                className="w-full h-80 object-cover cursor-pointer group-hover:scale-105 transition-transform duration-300 brightness-105 contrast-[1.12]"
                                            />
                                        </PhotoView>
                                        <span className="absolute top-3 left-3 rounded-md text-sm font-bold bg-amber-500/90 text-white px-2.5 py-1 shadow-sm backdrop-blur-sm">
                                            {trx?.user?.cabang?.nama_cabang}
                                        </span>
                                        <span className="absolute top-3 right-3 rounded-md text-sm font-bold bg-slate-900/70 text-white px-2.5 py-1 shadow-sm backdrop-blur-sm">
                                            {trx?.item?.karat} krt
                                        </span>
                                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#5C5C5C]/90 via-[#5C5C5C]/60 to-transparent pt-6 pb-2 px-4 flex flex-col gap-0.5 pointer-events-none">
                                            <span className="text-white text-lg lg:text-xl font-bold truncate leading-tight tracking-tight">{trx?.kode_trx} | {trx?.item?.jenis_kategori?.nama_jenis}</span>
                                            <span className="text-amber-400 text-lg lg:text-xl font-bold truncate leading-tight tracking-tight">{trx?.item?.berat} gr | Rata: Rp{' '}
                                                {numberWithCommas(
                                                    trx.total_harga == undefined ? '0' : Math.round(trx.total_harga / trx.item?.berat),
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                </div>
            </div>
            <div className="bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-700 bottom-0 flex justify-between left-0 py-3 w-full absolute">
                <div className="flex justify-end w-full mx-5">
                    <div className="items-center flex justify-center space-y-2 text-sm sm:space-y-0 sm:space-x-3 sm:flex">
                        <span className="block text-slate-600 dark:text-slate-400">
                            Halaman <span className="font-semibold text-amber-600 dark:text-amber-400">{currentPage}</span> dari <span className="font-semibold">{lastPage}</span>
                        </span>
                        <div className="space-x-1">
                            <button
                                onClick={() => setCurrentPage(currentPage - 1)}
                                disabled={currentPage <= 1}
                                title="previous"
                                type="button"
                                className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 rounded-md shadow-sm bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 disabled:opacity-40 transition-colors"
                            >
                                <IconChevronLeft size={18} />
                            </button>
                            <button
                                onClick={() => setCurrentPage(currentPage + 1)}
                                disabled={currentPage >= lastPage}
                                title="next"
                                type="button"
                                className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 rounded-md shadow-sm bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 disabled:opacity-40 transition-colors"
                            >
                                <IconChevronRight size={18} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Layouts>
    );
};

export default GaleriPenjualan;
